// extracted by mini-css-extract-plugin
module.exports = {"image":"DecksTable_image__mP9pe","row":"DecksTable_row__eFgWR","spinner":"DecksTable_spinner__p2jEX","table":"DecksTable_table__J4wV_"};